<template>
  <v-overlay
    v-model="isShow"
    :light="true" :dark="false"
  >
    <v-card class="popup-layout" :width="width" :max-width="maxWidth">
      <div class="popup-title-layout">
        <span class="popup-title">{{ title }}</span>
      </div>
      <slot name="content"></slot>
      <slot name="button"></slot>
    </v-card>
  </v-overlay>
</template>

<script>
export default {
  name: "PopupLayout",
  props: ["isShow", "width", "maxWidth", "title"]
}
</script>

<style lang="scss">
.popup-layout {
  padding: 10px 20px;
  .popup-title-layout {
    text-align: center;
    padding: 20px 0;
    .popup-title {
      font-size: 25px;
      font-weight: bold;
    }
  }
}
</style>